// Dialog cambio stato del preventivo PV (bozza -> in_preparazione -> inviato -> accettato/rifiutato -> convertito)
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
    Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../ui/dialog';
import {
    Clock, PaperPlaneTilt, Pencil, ArrowsClockwise, CheckCircle, XCircle, ArrowRight,
} from '@phosphor-icons/react';

export const QuoteStatusDialog = ({ open, onOpenChange, quote, status, onStatusChange }) => (
    <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>Cambia Stato Preventivo</DialogTitle>
                <DialogDescription asChild>
                    <div>
                        Stato attuale: <Badge className={status.color}>{status.label}</Badge>
                    </div>
                </DialogDescription>
            </DialogHeader>
            <div className="space-y-2 py-4">
                {quote.status === 'bozza' && (
                    <>
                        <Button 
                            variant="outline" 
                            className="w-full justify-start gap-2"
                            onClick={() => onStatusChange('in_preparazione')}
                        >
                            <Clock className="w-4 h-4" />
                            In Preparazione
                        </Button>
                        <Button 
                            variant="outline" 
                            className="w-full justify-start gap-2"
                            onClick={() => onStatusChange('inviato')}
                        >
                            <PaperPlaneTilt className="w-4 h-4" />
                            Invia al Cliente
                        </Button>
                    </>
                )}
                {quote.status === 'in_preparazione' && (
                    <>
                        <Button 
                            variant="outline" 
                            className="w-full justify-start gap-2"
                            onClick={() => onStatusChange('bozza')}
                        >
                            <Pencil className="w-4 h-4" />
                            Torna in Bozza
                        </Button>
                        <Button 
                            className="w-full justify-start gap-2"
                            onClick={() => onStatusChange('inviato')}
                        >
                            <PaperPlaneTilt className="w-4 h-4" />
                            Invia al Cliente
                        </Button>
                    </>
                )}
                {quote.status === 'inviato' && (
                    <>
                        <Button 
                            variant="outline" 
                            className="w-full justify-start gap-2"
                            onClick={() => onStatusChange('in_revisione')}
                        >
                            <ArrowsClockwise className="w-4 h-4" />
                            Richiedi Revisione
                        </Button>
                        <Button 
                            className="w-full justify-start gap-2 bg-green-600 hover:bg-green-700"
                            onClick={() => onStatusChange('accettato')}
                        >
                            <CheckCircle className="w-4 h-4" />
                            Accettato dal Cliente
                        </Button>
                        <Button 
                            variant="outline" 
                            className="w-full justify-start gap-2 text-red-600 hover:text-red-700"
                            onClick={() => onStatusChange('rifiutato')}
                        >
                            <XCircle className="w-4 h-4" />
                            Rifiutato
                        </Button>
                    </>
                )}
                {quote.status === 'in_revisione' && (
                    <Button 
                        className="w-full justify-start gap-2"
                        onClick={() => onStatusChange('inviato')}
                    >
                        <PaperPlaneTilt className="w-4 h-4" />
                        Invia Revisione
                    </Button>
                )}
                {quote.status === 'accettato' && (
                    <Button 
                        className="w-full justify-start gap-2 bg-emerald-600 hover:bg-emerald-700"
                        onClick={() => onStatusChange('convertito')}
                    >
                        <ArrowRight className="w-4 h-4" />
                        Converti in Contratto
                    </Button>
                )}
            </div>
        </DialogContent>
    </Dialog>
);
